import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Kaizen11.css";

function Kaizen11() {
  const [hasImplementedKaizen2, setHasImplementedKaizen2] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Ici vous pouvez ajouter la logique pour traiter le fichier
    console.log("Fichier sélectionné:", selectedFile);
  };

  return (
    <div className="container-center-horizontal">
      <div className="kaizen2-page screen">
        <div className="header">
          <Link to="/home">
            <img
              className="logo-icam"
              src="/img/1200px-logo-icam---2008-1@2x.png"
              alt="Logo ICAM"
            />
          </Link>
        </div>
        
        <div className="content-container">
          <h1 className="page-title">Méthodologie Kaizen - Étape 2</h1>
          
          <div className="question-section">
            <p className="question-text">
              Avez-vous déjà mis en place des actions d'amélioration continue dans votre entreprise ?
            </p>
            
            <div className="buttons-container">
              <button 
                className={`choice-button ${hasImplementedKaizen2 ? 'active' : ''}`}
                onClick={() => {
                  setHasImplementedKaizen2(true);
                  setShowFileUpload(true);
                }}
              >
                Oui
              </button>
              <button 
                className={`choice-button ${!hasImplementedKaizen2 ? 'active' : ''}`}
                onClick={() => {
                  setHasImplementedKaizen2(false);
                  setShowFileUpload(false);
                }}
              >
                Non
              </button>
            </div>

            {showFileUpload && (
              <div className="file-upload-section">
                <p className="upload-text">
                  Veuillez importer votre documentation sur les actions d'amélioration continue :
                </p>
                <form onSubmit={handleSubmit} className="upload-form">
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                    className="file-input"
                  />
                  <button type="submit" className="submit-button">
                    Importer
                  </button>
                </form>
              </div>
            )}

            {!hasImplementedKaizen2 && (
              <div className="redirect-section">
                <p className="redirect-text">
                  Nous vous recommandons de passer à la méthode SMED pour continuer votre démarche d'amélioration :
                </p>
                <Link to="/smed-1" className="redirect-button">
                  Passer à la méthode SMED
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kaizen11;
